import React from 'react'

const Statistics = () => {
    return (
        <div className='flex items-center justify-center h-full'>სტატისტიკა ვებ-გვერდის შესახებ <br /> Coming Soon...</div>
    )
}

export default Statistics